import { CrudApi } from './CrudApi';
import { ActionableModel } from '../models/actions/ActionableModel';

class ActionApi extends CrudApi<ActionableModel>{
	constructor(){
		super('action', (obj) => new ActionableModel().load(obj));
	}
}
export const actionApi = new ActionApi();